import { getExtendedPages } from '~/router/getExtendedPages';

export default defineNuxtPlugin({
  name: 'brandRoutes',
  async setup(nuxtApp) {
    const config = useRuntimeConfig();
    const { brand } = config.public;

    const routes = await getExtendedPages(brand);

    for (const route of routes) {
      nuxtApp.$router.addRoute(route);
    }
  },
});
